// extracted by mini-css-extract-plugin
module.exports = {"container":"KfLogo_container__1YjSM","image":"KfLogo_image__279ar","button":"KfLogo_button__2xmqL"};